export default "__VITE_ASSET__CYp2q$Lq__"